/**
 * ProPlusVideoModalLink — iter87.512
 *
 * Small "Watch the 30-second tour" text link placed beside the Free vs
 * Pro+ pricing table (`PricingCompareTable.jsx`). Opens the same
 * self-hosted promo video (/videos/rivalry-pro.mp4) in a modal so a
 * reader scanning pricing doesn't have to scroll back up to the hero.
 */
import React from "react";
import { Play } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger, DialogTitle } from "../components/ui/dialog";
import { PRO_PLUS_VIDEO_SRC, PRO_PLUS_VIDEO_POSTER } from "./ProPlusPromoVideo";

export default function ProPlusVideoModalLink({ className = "", label = "Watch the 30-second tour", plain = false, testId = "pro-plus-pricing-watch-tour-link" }) {
    return (
        <Dialog>
            <DialogTrigger asChild>
                <button
                    type="button"
                    data-testid={testId}
                    className={plain
                        ? `text-sky-400 hover:text-sky-300 underline underline-offset-2 transition-colors ${className}`
                        : `inline-flex items-center gap-1.5 text-xs text-sky-400 hover:text-sky-300 underline underline-offset-2 transition-colors ${className}`}
                >
                    {!plain && <Play className="w-3 h-3 shrink-0" fill="currentColor" />}
                    {label}
                </button>
            </DialogTrigger>
            <DialogContent
                className="max-w-3xl w-[95vw] bg-[#0a0a0a] border-[#2F80FF]/50 p-4 sm:p-6"
                data-testid="pro-plus-video-modal"
            >
                <DialogTitle className="text-white text-sm font-black uppercase tracking-widest text-left mb-1">
                    See Pro+ in 30 seconds
                </DialogTitle>
                <div
                    className="relative w-full aspect-video rounded-xl overflow-hidden border-2 border-[#2F80FF]/60 bg-black shadow-[0_0_40px_rgba(47,128,255,0.35)]"
                    data-testid="pro-plus-video-modal-player"
                >
                    <video
                        className="w-full h-full object-cover"
                        controls
                        playsInline
                        preload="metadata"
                        poster={PRO_PLUS_VIDEO_POSTER}
                        data-testid="pro-plus-video-modal-element"
                    >
                        <source src={PRO_PLUS_VIDEO_SRC} type="video/mp4" />
                        Your browser doesn't support embedded video — you can still{" "}
                        <a href={PRO_PLUS_VIDEO_SRC} className="text-sky-400 underline">
                            download the clip
                        </a>
                        .
                    </video>
                </div>
            </DialogContent>
        </Dialog>
    );
}
